import { useTranslation } from 'react-i18next';

const Filter = ({
  searchQuery,
  setSearchQuery,
  setStatusFilter,
  STATUS_CONFIG,
  statusFilter,
  S,
  setAssigneeFilter,
  assignees,
  dateFromFilter,
  setDateFromFilter,
  dateToFilter,
  setDateToFilter,
  assigneeFilter,
}) => {
  const { t } = useTranslation();
  const statusLabelMap = {
    reported: t('screens.claimsScreen.statusReported'),
    new: t('screens.claimsScreen.statusReported'),
    open: t('screens.claimsScreen.statusOpen'),
    review: t('screens.claimsScreen.statusReview'),
    investigation: t('screens.claimsScreen.statusInvestigation'),
    approved: t('screens.claimsScreen.statusApproved'),
    closed: t('screens.claimsScreen.statusClosed'),
  };
  return (
    <div
      style={{
        padding: '16px 32px',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.5)',
        flexShrink: 0,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ position: 'relative', flex: 1, maxWidth: 400 }}>
        <div style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }}>
          <svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='#94a3b8' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
            <circle cx='11' cy='11' r='8' />
            <line x1='21' y1='21' x2='16.65' y2='16.65' />
          </svg>
        </div>
        <input
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder={t('screens.claimsScreen.searchPlaceholder')}
          style={{
            width: '100%',
            padding: '9px 12px 9px 36px',
            background: '#fff',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 8,
            fontSize: 13,
            color: S.textPrimary,
            outline: 'none',
            fontFamily: 'inherit',
          }}
        />
      </div>
      {/* 'new' is a legacy alias for 'reported' — collapsed into one button.
          Backend maps status=reported → { $in: ['reported', 'new'] }. */}
      {['all', 'reported', 'open', 'review', 'investigation', 'approved', 'closed'].map(s => (
        <button
          key={s}
          onClick={() => setStatusFilter(s)}
          style={{
            padding: '7px 14px',
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
            border: statusFilter === s ? `1px solid ${S.burgundy}` : `1px solid ${S.borderLight}`,
            background: statusFilter === s ? 'rgba(128,0,32,0.07)' : '#fff',
            color: statusFilter === s ? S.burgundy : S.textSecondary,
          }}
        >
          {s === 'all' ? t('screens.claimsScreen.allClaims') : statusLabelMap[s] || STATUS_CONFIG[s]?.label || s}
        </button>
      ))}
      <select
        value={assigneeFilter}
        onChange={e => setAssigneeFilter(e.target.value)}
        style={{
          padding: '7px 12px',
          borderRadius: 8,
          fontSize: 12,
          fontWeight: 600,
          border: `1px solid ${S.borderLight}`,
          background: '#fff',
          color: S.textSecondary,
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        <option value='all'>{t('screens.claimsScreen.allAssignees')}</option>
        <option value='unassigned'>{t('screens.claimsScreen.unassigned')}</option>
        {assignees.map(u => (
          <option key={u.id} value={u.id}>
            {u.name}
          </option>
        ))}
      </select>
      <div
        style={{
          display: 'flex',
          gap: 10,
          alignItems: 'center',
          width: '100%',
        }}
      >
        <input
          type='date'
          value={dateFromFilter}
          onChange={e => setDateFromFilter(e.target.value)}
          style={{
            padding: '7px 12px',
            borderRadius: 8,
            fontSize: 12,
            border: `1px solid ${S.borderLight}`,
            background: '#fff',
            color: S.textSecondary,
            outline: 'none',
          }}
          title={t('screens.claimsScreen.filterDateFromTitle')}
        />
        <input
          type='date'
          value={dateToFilter}
          onChange={e => setDateToFilter(e.target.value)}
          style={{
            padding: '7px 12px',
            borderRadius: 8,
            fontSize: 12,
            border: `1px solid ${S.borderLight}`,
            background: '#fff',
            color: S.textSecondary,
            outline: 'none',
          }}
          title={t('screens.claimsScreen.filterDateToTitle')}
        />
      </div>
    </div>
  );
};

export default Filter;
